import React from "react";
import styled, { keyframes } from "styled-components";

const epicIn = keyframes`
  0% { opacity: 0; transform: translateY(20px) scale(0.98); }
  60% { opacity: 1; transform: translateY(0) scale(1.02); }
  100% { opacity: 1; transform: translateY(0) scale(1); }
`;

const IntroHeader = styled.h1`
  font-family: 'Geist Variable', 'Geist', sans-serif;
  font-weight: 500;
  font-size: clamp(30px, 6vw, 30px);
  text-align: left;
  line-height: 1.05;
  margin: 0;
  letter-spacing: 0.5px;
  color: oklch(.145 0 0);
  animation: ${epicIn} 800ms ease-out both;
`;

const IntroText = styled.p`
  font-family: 'Geist Variable', 'Geist', sans-serif;
  font-size: clamp(15px, 2.2vw, 18px);
  color: #374151;
  margin: 10px 0 0 0;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 16px;
  flex-wrap: wrap;
`;

const DownloadButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 14px;
  border-radius: 8px;
  background: #ffffff;
  color: ${(p) => p.$accentColor || '#2d70e2'};
  border: 1px solid currentColor;
  text-decoration: none;
  font-weight: 600;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
  transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.02s ease;

  &:hover {
    background: #f8fafc;
  }

  &:active {
    transform: translateY(1px);
  }
`;

const CheckboxRow = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #374151;
  font-size: 14px;
`;

const NoteText = styled.div`
  font-size: 12px;
  color: #6b7280;
`;

export default function Introduction({ themeColors, reportUrl, language = 'EN', acknowledged = false, onAcknowledgeChange }) {

  const copy = {
    EN: {
      header: 'Welcome to your action planning module.',
      subtitle1: 'This process is designed to help you set effective actions based on your report.',
      subtitle2: 'Please ensure you have read your report before proceeding.',
      download: 'Download Your Report',
      confirmRead: 'I have read my report',
      note: 'Please make sure you’ve read your PDF report first.',
    },
    FR: {
      header: 'Bienvenue dans votre processus de plan d’action',
      subtitle1: 'Ce processus est conçu pour vous aider à définir des actions efficaces pour votre magasin.',
      subtitle2: 'Veuillez vous assurer d’avoir lu d’abord votre rapport PDF.',
      download: 'Télécharger votre rapport',
      confirmRead: 'J’ai lu mon rapport',
      note: 'Poursuivre sans examen peut mener à des actions moins efficaces.',
    },
    ES: {
      header: 'Bienvenido a tu proceso de planificación de acciones',
      subtitle1: 'Este proceso está diseñado para ayudarte a definir acciones efectivas para tu tienda.',
      subtitle2: 'Asegúrate de haber leído primero tu informe en PDF.',
      download: 'Descargar tu informe',
      confirmRead: 'He leído mi informe',
      note: 'Continuar sin revisar puede llevar a acciones menos efectivas.',
    },
  };
  const t = copy[language] || copy.EN;

  return (
    <div>
      <IntroHeader>{t.header}</IntroHeader>
      <IntroText>{t.subtitle1}</IntroText>
      <IntroText>{t.subtitle2}</IntroText>
      <Actions>
        <DownloadButton
          href={reportUrl || "#"}
          target="_blank"
          rel="noopener noreferrer"
          $accentColor={themeColors?.buttonColor}
        >
          {t.download}
        </DownloadButton>
        <div>
          <CheckboxRow>
            <input
              type="checkbox"
              checked={acknowledged}
              onChange={(e) => onAcknowledgeChange && onAcknowledgeChange(e.target.checked)}
            />
            {t.confirmRead}
          </CheckboxRow>
        </div>
      </Actions>
    </div>
  );
}

